import { I18n } from 'react-redux-i18n';
import * as actions from '../actionsList';

const idealProfileScalesTableActions = [
  {
    name: actions.SAVE_IDEAL_PROFILE_CHANGES,
    label: I18n.t('Save'),
  },
];

export default idealProfileScalesTableActions;
